import { CLIENTTRANSACTIONREPORTS__MUTATIONS } from "../mutation-types";
import { CLIENTTRANSACTIONREPORTS__ACTIONS } from "../action-types";
import { CLIENTTRANSACTIONREPORTS__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

// State
const state = {
  transactionReports: {
    reports: [],
    totalDeposit: 0,
    totalWithdrawal: 0,
    businessLevel: 0,
  },
};

const getters = {};

// Mutations
const mutations = {
  [CLIENTTRANSACTIONREPORTS__MUTATIONS.TRANSACTIONREPORTS](state, data) {
    state.transactionReports.reports = data?.data;
    state.transactionReports.totalDeposit = data?.totalDeposit;
    state.transactionReports.totalWithdrawal = data?.totalWithdrawal;
    state.transactionReports.businessLevel = data?.businessLevel;
  },
};

// Actions
const actions = {
  async [CLIENTTRANSACTIONREPORTS__ACTIONS.TRANSACTIONREPORTS](
    { commit },
    parameter
  ) {
    try {
      const levelParam =
        parameter?.level != null ? `level=${parameter.level}` : "";
      const trxTypeParam =
        parameter?.trx_type != null ? `trx_type=${parameter.trx_type}` : "";
      const durationParam =
        parameter?.duration != null ? `duration=${parameter.duration}` : "";

      const queryParams = [levelParam, trxTypeParam, durationParam]
        .filter((param) => param !== "")
        .join("&");

      const { data } = await http().get(
        CLIENTTRANSACTIONREPORTS__API.TRANSACTIONREPORTS +
          (queryParams !== "" ? `?${queryParams}` : "")
      );

      commit(CLIENTTRANSACTIONREPORTS__MUTATIONS.TRANSACTIONREPORTS, data);
    } catch (error) {
      console.error("Error fetching transactions reports:", error);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
